import {createReducer} from 'utils/redux';
import {SET_FOLLOWING_STRATEGIES, UNFOLLOW_STRATEGY, FOLLOW_STRATEGY} from 'actions/followingStrategies';

const initialState = [];

export default createReducer(initialState, {
  [SET_FOLLOWING_STRATEGIES]: (state, {payload = initialState}) => payload,
  [UNFOLLOW_STRATEGY]: (state, {payload: strategyId}) => state.filter(({id}) => id !== strategyId),
  [FOLLOW_STRATEGY]: (state, {payload: strategy}) => [...state, strategy],
});
